module.exports = __webpack_public_path__ + "static/media/sport-boxing.21b2e792.vtt";